import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    getnextdayemprooster, getView, myData
} from "../dbconnector/connector";
import { setErrorMessage, setMessage } from "../tools/errorhandling";
import moment from 'moment';
import { MdOutlineAddBox } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { BiSolidMessageSquareError } from "react-icons/bi";
import { FaExclamationCircle } from "react-icons/fa";
import { BsFillMoonStarsFill } from "react-icons/bs";
import { LiaHotelSolid } from "react-icons/lia";
import { FaSourcetree } from "react-icons/fa";


const EmployeeRoosterNode = ({ saveError, translation, setNeedupdate, Employee, hasholiday, index, events, hotelid, datum, hotelnormen, disabled, canEdit, isapproved, data, dataishere, classindex, getnorm,nr_afd}) => {

    const t = translation;
    const [blijver, setBlijver] = useState(0);
    const [vertrekker, setVertrekker] = useState(0);
    const [AD, setAD] = useState(0);
    const [Vrij, setVrij] = useState(0);
    const [norm, setNorm] = useState(0);
    const [VM_Beginuur, setVM_Beginuur] = useState('09:30:00');
    const [VM_Einduur, setVM_Einduur] = useState('12:00:00');
    const [Pauze, setPauze] = useState('12:30:00');
    const [RoosterApproved, setRoosterApproved] = useState(0);
    const [NM_Beginuur, setNM_Beginuur] = useState('12:30:00');
    const [NM_Einduur, setNM_Einduur] = useState('15:00:00');
    const [showVMbegin, setshowVMbegin] = useState(true);
    const [nightshift, setNightshift] = useState(false);
    const [showVMInputs, setshowVMInputs] = useState(false);
    const [showNMInputs, setshowNMInputs] = useState(false);
    const [disableNM, setdisableNM] = useState(true);
    const [showbreak, setshowbreak] = useState(false);
    const [error, setError] = useState(null)
    const [nonworkingday, SetNonWorkingDay] = useState(false)
    const [addtorooster, setAddtorooster] = useState(true)
    const [afwezigheidstype, setAfwezigheidstype] = useState(hasholiday ? 5 : 0);


    const getData = () => {
        if (dataishere === true) {

            populateFields(data[0]);
        } else {
            //console.log(Employee)
            getnextdayemprooster(Employee.id, hotelid, datum).then((response) => {
                if (response.status === 200) {
                    response.json().then((roosters) => {

                        if (roosters.length === 1) {
                            populateFields(roosters[0]);

                        }
                        if (roosters.length > 1) {
                            let indexcopy = index;
                            let EmployeeRoosterNodes = [];
                            roosters.forEach((rooster, ind) => {
                                if (ind === 0) {
                                    populateFields(rooster);
                                }
                                if (ind > 0) {
                                    indexcopy += 1;
                                    EmployeeRoosterNodes.push({
                                        index: indexcopy, node: {

                                            data: [rooster],
                                            dataishere: true,
                                            translation: t,
                                            setNeedupdate,
                                            Employee,
                                            hasholiday: hasholiday,
                                            indexcopy,
                                            events: {
                                                selectrow: events.selectrow,
                                                calc: events.calc,
                                                calctotal: events.calctotal,
                                                fillblijver: events.fillblijver,
                                                fillvertrekker: events.fillvertrekker,
                                                fillAD: events.fillAD,
                                                fillnorm: events.fillnorm,
                                                duplicateroosternode: events.duplicateroosternode,
                                                addcleaner: events.addcleaner,
                                                removecleaner: events.removecleaner,
                                                checkcleanerTotalHours: events.checkcleanerTotalHours,
                                                addEmployeeRoosterNode: events.addEmployeeRoosterNode,
                                                changecleanerprops: events.changecleanerprops,
                                                startdrag: events.startdrag
                                            },
                                            hotelid,
                                            datum,
                                            disabled,
                                            canEdit,
                                            isapproved
                                        }
                                    })
                                }
                            })
                            events.addEmployeeRoosterNode(EmployeeRoosterNodes);
                        }
                    });
                }
            });
        }
    }



    useEffect(() => {
        CheckNonWorkingdaysofuser(Employee);

        getData();
        if(nr_afd === Employee.nr_afd)
            console.log("nr_afd= ", nr_afd, "/  employee.nr_afd= ", Employee.nr_afd)
    }, [Employee]);




    useEffect(() => {
        ////////////console.log("saveError", saveError,Employee.voornaam, Employee.achternaam);
        if (saveError) {
            setError(saveError)
        } else {
            setError(null);
        };
    }, [saveError]);

    const CheckNonWorkingdaysofuser = (Employee) => {

        var daynumber = new Date(datum).getDay();
        if (daynumber === 0) {
            if (Employee.zondag === 1) {
                //SetNonWorkingDay(true)
                setAfwezigheidstype(Employee.zondag === 1 ? 3 : afwezigheidstype)
            } else { SetNonWorkingDay(false) }
        }
        else if (daynumber === 1) {
            if (Employee.maandag === 1) {
                //SetNonWorkingDay(true)
                setAfwezigheidstype(Employee.maandag === 1 ? 3 : afwezigheidstype)
            } else { SetNonWorkingDay(false) }
        }
        else if (daynumber === 2) {
            if (Employee.dinsdag === 1) {
                //SetNonWorkingDay(true)
                setAfwezigheidstype(Employee.dinsdag === 1 ? 3 : afwezigheidstype)
            } else { SetNonWorkingDay(false) }
        }
        else if (daynumber === 3) {
            if (Employee.woensdag === 1) {
                //SetNonWorkingDay(true)
                setAfwezigheidstype(Employee.woensdag === 1 ? 3 : afwezigheidstype)
            } else { SetNonWorkingDay(false) }
        }
        else if (daynumber === 4) {
            if (Employee.donderdag === 1) {
                //SetNonWorkingDay(true)
                setAfwezigheidstype(Employee.donderdag === 1 ? 3 : afwezigheidstype)
            } else { SetNonWorkingDay(false) }
        }
        else if (daynumber === 5) {
            if (Employee.vrijdag === 1) {
                //SetNonWorkingDay(true)
                setAfwezigheidstype(Employee.vrijdag === 1 ? 3 : afwezigheidstype)
            } else { SetNonWorkingDay(false) }
        }
        else if (daynumber === 6) {
            if (Employee.zaterdag === 1) {
                //SetNonWorkingDay(true)
                setAfwezigheidstype(Employee.zaterdag === 1 ? 3 : afwezigheidstype)
            } else { SetNonWorkingDay(false) }
        }
    }
    const safeValue = (val, fallback) => (val === '' || val === null || val === undefined ? fallback : val);

    const populateFields = (rooster) => {


        events.fillblijver(Employee.id + "_" + index, rooster.blijver);
        events.fillvertrekker(Employee.id + "_" + index, rooster.vertrekker);
        events.fillAD(Employee.id + "_" + index, rooster.AD);
        setBlijver(safeValue(rooster.blijver, 0));
        setVertrekker(safeValue(rooster.vertrekker, 0));
        setAD(safeValue(rooster.AD, 0));
        setVrij(safeValue(rooster.Vrij, 0));
        setVM_Beginuur(safeValue(rooster.VM_Beginuur, '09:30:00'));
        setVM_Einduur(safeValue(rooster.VM_Einduur, '12:00:00'));
        setPauze(safeValue(rooster.Pauze, '12:30:00'));
        setNM_Beginuur(safeValue(rooster.NM_Beginuur, '12:30:00'));
        setNM_Einduur(safeValue(rooster.NM_Einduur, '15:00:00'));
        if (hasholiday === false && rooster.afwezigheidstype === "5") {
            setAfwezigheidstype(0)
         } else {
            setAfwezigheidstype(safeValue(rooster.afwezigheidstype, hasholiday ? 5 : 0));
        }
        setRoosterApproved(isapproved)
    };

    const handleChange = (e) => {
        let { name, value } = e.target;
        if (name.includes("?blijver") || name.includes("?vertrekker")) {
            if (value.length === 0) {
                value = 0
            }
            value = safeValue(parseInt(value), 0)
            e.target.value = value
        }
        if (name.includes("?AD") || name.includes("?Vrij")) {
            if (value.length === 0) {
                value = 0
            }
            value = parseFloat(value)
            e.target.value = value
        }
        if (name.includes("?NM_Beginuur") && value !== "12:30:00") {
            setVM_Beginuur(value);
        }

        if (name.includes("?blijver")) {
            setBlijver(safeValue(Number(value), 0))
            events.fillblijver(Employee.id + "_" + index, Number(value));
        }
        else if (name.includes("?vertrekker")) {

            setVertrekker(safeValue(Number(value), 0));
            events.fillvertrekker(Employee.id + "_" + index, Number(value));
        }
        else if (name.includes("?AD")) {
            setAD(safeValue(Number(value), 0));
            events.fillAD(Employee.id + "_" + index, Number(value));
        }
        else if (name.includes("?Vrij")) setVrij(safeValue(Number(value), 0));
        else if (name.includes("?VM_Beginuur")) setVM_Beginuur(safeValue(value, '09:30:00'));
        else if (name.includes("?VM_Einduur")) setVM_Einduur(safeValue(value, '12:00:00'));
        else if (name.includes("?Pauze")) setPauze(safeValue(value, '12:30:00'));
        else if (name.includes("?NM_Beginuur")) setNM_Beginuur(safeValue(value, '12:30:00'));
        else if (name.includes("?NM_Einduur")) setNM_Einduur(safeValue(value, '15:00:00'));
        else if (name.includes("?afwezigheidstype")) setAfwezigheidstype(safeValue(Number(value), hasholiday ? 5 : 0));
        else if (name.includes("?approved")) setRoosterApproved(safeValue(value, 0));
        else if (name.includes("?nighshift")) setNightshift(safeValue(value, 0));
    };
    const handleSelect = (e) => {
        e.target.focus()
        events.selectrow(e.target.name, e.target.name.split("?")[0], "focus")
    };

    useEffect(() => {

        if (hotelnormen && hotelnormen.norm && hotelnormen.norm !== undefined) {
            const blijvernorm = hotelnormen.norm.blijversad
            const vertrekkersnorm = hotelnormen.norm.vertrekkersad
            const totalhoursscheduled = (blijver / blijvernorm) + (vertrekker / vertrekkersnorm) + Number(AD) + Number(Vrij)

            recalc_hours(totalhoursscheduled * 60);
            setNorm(Number(totalhoursscheduled).toFixed(2));
            events.fillnorm(Employee.id + "_" + index, Number(totalhoursscheduled).toFixed(2));
        }

    }, [blijver, vertrekker, AD, Vrij, VM_Beginuur, hotelnormen]);

    const donothing = () => {
    }
    const recalc_hours = (workinhours) => {

        setdisableNM(true);
        setshowNMInputs(false);
        setshowVMInputs(false);
        setshowVMbegin(false);
        if (workinhours === 0) {
            setVM_Einduur("12:00:00");
            setNM_Einduur("00:00:00");
            setNM_Beginuur("12:30:00");
            //setVM_Beginuur("09:30:00");
            setshowNMInputs(false);
            setshowVMInputs(false);
            setshowVMbegin(true);
            setshowbreak(false);
        } else {
            const startMoment = moment(`${moment().format("YYYY-MM-DD")} ${VM_Beginuur}`, 'YYYY-MM-DD HH:mm:ss');
            const endMoment = startMoment.clone().add(workinhours, 'minutes');
            if (startMoment.format('HH:mm:ss') > "12:00:00") {
                setshowVMbegin(false);
                setshowVMInputs(false);
                setshowNMInputs(true);
                setNM_Beginuur(startMoment.format('HH:mm:ss'));
                setdisableNM(false);
            } else {
                setNM_Beginuur("12:30:00");
                setshowNMInputs(false);
                setshowVMInputs(false);
                setshowVMbegin(true);
            }
            if (endMoment.format('HH:mm:ss') < "12:01:00" && startMoment.format('HH:mm:ss') < "12:00:00") {

                setVM_Einduur(endMoment.format('HH:mm:ss'));
                setshowVMInputs(true);
                setshowVMbegin(true);
            } else {
                setVM_Einduur("12:00:00");
                let extendedEnd = endMoment.clone();
                if (startMoment.format('HH:mm:ss') < "12:30:00") {
                    extendedEnd = endMoment.clone().add(30, 'minutes'); // lunch break
                }
                if (startMoment.format('HH:mm:ss') < "12:30:00") {
                    if (startMoment.format('HH:mm:ss') > "12:00:00") {
                        setVM_Beginuur("12:00:00");
                    }
                }
                setNM_Einduur(extendedEnd.format('HH:mm:ss'));
                setshowNMInputs(true);
                setshowVMInputs(true);
                setshowVMbegin(true);
                setshowbreak(true);
                if (startMoment.format('HH:mm:ss') > "12:00:00") {
                    setshowVMbegin(false);
                    setshowVMInputs(false);
                    setNM_Beginuur(startMoment.format('HH:mm:ss'));
                    setshowbreak(false);
                }
            }
            //console.log("startMoment", startMoment.format('HH:mm:ss'))
            let extendedEnd = endMoment.clone();
            if ((workinhours / 60) >= 4) {
                extendedEnd = endMoment.clone().add(30, 'minutes'); // lunch break also for nightshift
                setNM_Einduur(extendedEnd.format('HH:mm:ss'));
            }
            if (extendedEnd.format('HH:mm:ss') < "12:01:00" && startMoment.format('HH:mm:ss') > "12:00:00") {
                setNightshift(1)
            } else {
                setNightshift(0)
            }
        }

        events.checkcleanerTotalHours(workinhours, Employee.id, index);
    }
//if(nr_afd === Employee.nr_afd)
    return (
        <>
            <div id={Employee.id + "_" + index} className={classindex % 2 === 0 ? hotelcss.linkVarient1_rooster : hotelcss.linkVarient2_rooster } onSelect={handleSelect}>
                <div id={Employee.id + "_" + index + "_add"} style={dataishere === false && error === null ? { display: "block" } : { display: "none" }}>
                    <MdOutlineAddBox className='duplicateroosternode' onClick={() => events.addcleaner(Employee, index)} style={canEdit && Employee.actief === 1 && !RoosterApproved ? { display: 'block' } : { display: 'none' }} />
                    <FaExclamationCircle className='historicaldetails' onClick={() => events.showhistoricaldetails(Employee)} style={canEdit || Employee.actief === 1 ? { display: 'none' } : { display: 'block' }} />
                </div>
                <div id={Employee.id + "_" + index + "_delete"} style={dataishere === true && error === null ? { display: "block" } : { display: "none" }}>
                    <MdDelete className='duplicateroosternode' onClick={() => events.removecleaner(Employee.id + "_" + index, index)} disabled={hasholiday || nonworkingday || disabled || RoosterApproved} style={canEdit || Employee.actief === 1 ? { display: 'none' } : { display: 'block' }} />
                </div>
                <div id={Employee.id + "_" + index + "_error"} style={error !== null ? { display: "block" } : { display: "none" }} className="tip"><BiSolidMessageSquareError className='errorroosternode' />
                    <span className="tiptext">{error}</span>
                </div>

                <p>{Employee.achternaam} {Employee.voornaam} </p>
                <div className="gridinput"><FaSourcetree style={nr_afd === Employee.nr_afd? { visibility: 'visible' } : { visibility: 'hidden' }} /> </div>
                <input type="number" id={Employee.id + "_" + index + "?blijver"} name={Employee.id + "_" + index + "?blijver"} onSelect={handleSelect} onChange={handleChange} value={blijver} className="gridinput" disabled={hasholiday || nonworkingday || disabled || RoosterApproved}
                    min="0.00"
                    step="1"
                    presicion={0}
                ></input>
                <input type="number" id={Employee.id + "_" + index + "?vertrekker"} name={Employee.id + "_" + index + "?vertrekker"} onSelect={handleSelect} onChange={handleChange} value={vertrekker} className="gridinput" disabled={hasholiday || nonworkingday || disabled || RoosterApproved}
                    min="0.00"
                    step="1"
                    presicion={0}
                ></input>
                <input type="number"
                    min="0.00"
                    step="0.1"
                    max="10.00"
                    presicion={2}
                    id={Employee.id + "_" + index + "?AD"} name={Employee.id + "_" + index + "?AD"} value={AD} onSelect={handleSelect} onChange={handleChange} className="gridinput" disabled={hasholiday || nonworkingday || disabled || RoosterApproved}></input>
                <div className='nightshift' style={nightshift ? { visibility: 'visible' } : { visibility: 'hidden' }}><BsFillMoonStarsFill /></div>

                <input type="number" id={Employee.id + "_" + index + "?Vrij"} name={Employee.id + "_" + index + "?Vrij"} value={Vrij} onSelect={handleSelect} onChange={handleChange} className="gridinputsmaller" disabled={hasholiday || nonworkingday || disabled || RoosterApproved}
                    min="0.00"
                    step="0.1"
                    max="10.00"
                    presicion={2}
                >
                </input>
                <div className={hotelcss.gridLineR}>
                    <input type="time" name={`${Employee.id}_${index}?VM_Beginuur`} style={{ visibility: showVMbegin ? 'visible' : 'hidden' }} max="22:00:00" min="06:00:00" value={VM_Beginuur} onChange={handleChange} className="gridinput" disabled={hasholiday || nonworkingday || disabled || RoosterApproved} />
                </div>
                <div className={hotelcss.gridLineL}>
                    <input type="time" name={`${Employee.id}_${index}?VM_Einduur`} style={{ visibility: showVMInputs ? 'visible' : 'hidden' }} value={VM_Einduur} className="gridinput" disabled={hasholiday || nonworkingday || disabled || RoosterApproved} onChange={donothing} />
                </div>
                <input type="time" name={`${Employee.id}_${index}?Pauze`} style={{ visibility: showbreak ? 'visible' : 'hidden' }} value={Pauze} className="gridinput" disabled onChange={donothing} />
                <div className={hotelcss.gridLineR}>
                    <input type="time" id={`${Employee.id}_${index}?NM_Beginuur`} name={`${Employee.id}_${index}?NM_Beginuur`} style={{ visibility: showNMInputs ? 'visible' : 'hidden' }} value={NM_Beginuur} onChange={handleChange} className="gridinput" disabled={hasholiday || nonworkingday || disabled || RoosterApproved} />
                </div>
                <div className={hotelcss.gridLineL}>
                    <input type="time" name={`${Employee.id}_${index}?NM_Einduur`} style={{ visibility: showNMInputs ? 'visible' : 'hidden' }} value={NM_Einduur} className="gridinput" disabled={hasholiday || nonworkingday || disabled || RoosterApproved} onChange={donothing} />
                </div>

                <input type="decimal" id={Employee.id + "_" + index + "?norm"} className="norm" disabled onChange={handleChange}
                    min="0.00"
                    step="0.5"
                    max="10.00"
                    presicion={2} value={norm} ></input>
                <select className='EW' id={Employee.id + "_" + index + "?afwezigheidstype"} name={Employee.id + "_" + index + "?afwezigheidstype"} value={hasholiday ? 5 : afwezigheidstype} onSelect={handleSelect} onChange={handleChange} disabled={hasholiday || nonworkingday || disabled || RoosterApproved} >
                    <option>-</option>
                    <option value="1">{t('Economisch werkloos')}</option>
                    <option value="2">{t('Ziek')}</option>
                    <option value="3">{t('Vrij')}</option>
                    <option value="4">{t('Verlof')}</option>
                    <option value="5">{t('Vakantie')}</option>
                </select>
                <div>
                    <input style={{ visibility: 'hidden' }} type="checkbox" id={Employee.id + "_" + index + "?nightshift"} className="norm" name={`${Employee.id}_${index}?nightshift`} checked={nightshift} value={nightshift} onChange={donothing}>
                    </input>
                    <input style={{ visibility: 'hidden' }} type="text" id={Employee.id + "_" + index + "?approved"} className="norm" name={`${Employee.id}_${index}?approved`} value={RoosterApproved} disabled={RoosterApproved} onChange={donothing}>
                    </input>
                </div>

            </div>
        </>
    );
}

export default EmployeeRoosterNode;
